import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MobileStatusRemoteDto } from '../../../../generated/signalR/mobile-status-remote-dto';
import { MobileStatusType } from '../../../samwebDescription/samweb/contactStatus/mobileStatusType';
import { MobileStatusState } from '../../../store/samwin/contact-states/mobile-status/mobile-status.state';

@Component({
   selector: 'samweb-mobile-status',
   templateUrl: './mobile-status.component.html',
   styleUrls: ['./mobile-status.component.scss'],
})
export class MobileStatusComponent implements AfterViewInit, OnDestroy, OnChanges {
   constructor(private store: Store) {}
   private destroy$ = new Subject();

   @Input()
   public fixedWidth: boolean;

   @Input()
   public mobilePresenceId: string;

   public mobileStatus$: Observable<{ mobileStatus: MobileStatusType; mobileState: MobileStatusRemoteDto }>;

   // Is needed for virtual scrolling, the data would not update correctly otherwise.
   ngOnChanges(changes: SimpleChanges): void {
      if (changes?.mobilePresenceId?.previousValue !== changes?.mobilePresenceId?.currentValue) {
         this.ngAfterViewInit();
      }
   }

   ngAfterViewInit(): void {
      this.mobileStatus$ = this.store.select(MobileStatusState.getMobileStateSelector(this.mobilePresenceId)).pipe(takeUntil(this.destroy$));
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
